import { globalData } from '..';
import { toggleSound } from '../components/messages/sounds';
import params from '../params';

//IMPORTANT ID NAMES RE-USED IN LAYOUT
const ID_NAMES = Object.freeze({
    LAYOUT: 'CHAT_HEAD_LAYOUT',
    BUBBLE: 'CHAT_HEAD_BUBBLE',
    CHAT: 'CHAT_HEAD_CHAT',
    CHAT_MESSAGES: 'CHAT_HEAD_MESSSAGES',
    JUMPING_DOTS: 'CHAT_HEAD_JUMPING_DOTS',
    BUBBLE_INSIDE: 'CHAT_HEAD_BUBBLE_INSIDE',
    VIDEO: 'CHAT_HEAD_VIDEO',
    PRELOAD_VIDEO: 'CHAT_HEAD_PRELOAD_VIDEO',
    IFRAME: 'CHAT_HEAD_IFRAME',
    SOUND: 'CHAT_HEAD_SOUND',
    AFTER_PLAYER_CTA: 'CHAT_HEADER_AFTER_PLAYER_CTA',
    AVATAR: "CHAT_HEAD_AVATAR"
})


const getEnv = () => {

    let { cheadTest, localTest } = params();

    //GET THE FULL SRC PATH OF THE CURRENT SCRIPT, SHOULD BE A GATEWAY URL FOR PRODUCTION
    const scripts = [...document.getElementsByTagName('script')];

    //BACKUP ORIGIN IF NO SRC FOUND THAT MATCHES
    let origin = 'https://gateway.jerkmate.com'

    //USE GATEWAY DOMAIN FROM ORIGIN OR SCRIPT.SRC OF THIS FILE. LOCALHOST OR PARAM cheadTest DEFAULTS TO STAGING
    let env = 'production'

    //GET ORIGIN URL OF THE CURRENT FILE
    for (let i = 0; i < scripts.length; i++) {
        const { src } = scripts[i] || {}
        if (src?.includes('chathead.min.js') && src?.includes('gateway')) {
            origin = new URL(src)?.origin;
            break
        }
    }

    const localhost = window?.location?.href?.includes('localhost')

    if (localhost && localTest) {
        env = 'localhost'
    } else if (cheadTest || localhost) {
        env = 'staging'
    }

    const urls = {
        staging: `https://gateway.staging.hydrahub.io/cmscloud`,
        production: `${origin}/cmscloud`,
        localhost: `https://gateway.staging.hydrahub.io/cmscloud`
    }

    return { env, urls }

}

//ASSET URL
const assetUrl = (path) => {

    if (!path) {
        return
    }

    const { urls, env } = getEnv();

    return `${urls[env]}${path}`

}


//OUTLINK
const returnUrl = (div) => {
    const { ctaOutlink, pname, smid } = globalData;

    const sessionData = JSON.parse(localStorage.getItem('hydra'))['session-widget']?.session;

    const replaceTokens = (url, session = {}, extraParams = {}) => {
        let newUrl = url
        const paramsObject = { ...session, ...extraParams }

        Object.keys(paramsObject).forEach((key) => {
            const reg = new RegExp(`{${key}}`, 'g')
            newUrl = newUrl?.replace(reg, paramsObject[key] || '')

            if (['ccode', 'up'].includes(key)) {
                newUrl += `&${key}=${paramsObject[key]}`
            }
        })

        try {
            return new URL(newUrl).href
        } catch {
            console.error('Wrong URL format', `old: ${url}`, `new: ${newUrl}`)
            return ''
        }
    }

    //MUTE SOUND WHEN LINK IS CLICKED
    div.addEventListener("click", () => {
        toggleSound({ forceMute: true })
    })

    div.setAttribute("target", "_blank")
    div.setAttribute("rel", "noreferrer")
    div.href = replaceTokens(ctaOutlink, sessionData, { pname, smid })

}

//PUSH TO DATALAYER
const pushToDataLayer = data => {
    const errors = []
    const dataToPush = {
        ...data,
        eventAction: data.eventAction || 'click',
        event: 'UA_CREvent'
    }

    const validationObj = ['eventCategory', 'eventLabel', 'eventAction']

    const validate = event => typeof dataToPush[event] === 'string'

    validationObj.forEach(
        event => validate(event) || errors.push(`${event} invalid or missing`)
    )

    //ONLY PUSH IF DATA LAYER EXISTS
    if (!errors.length && window?.dataLayer) {
        window.dataLayer.push(dataToPush)
    } else {
        console.error(errors)
    }
}


const processGender = () => {

    let { gender } = params();

    let genderType = ''

    switch (gender) {
        case 'f':
        default:
            genderType = 'female'
            break
        case 'm':
            genderType = 'male'
            break
        case 'c':
            genderType = 'couples'
            break
        case 't':
            genderType = 'trans'
            break
    }

    return globalData[genderType]

}

export { assetUrl, ID_NAMES, returnUrl, pushToDataLayer, getEnv, processGender }